class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
  
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
      
      // const swiperNotice = swiperFun();
      // swiperNotice.init();
     // 总金额变化 进度条变化 start
  
      // 总金额变化 进度条变化 end
      // var cartContents = fetch(window.Shopify.routes.root + "cart.js")
      //   .then((response) => response.json())
      //   .then((data) => {
      //     console.log(123123)
      //     var cartList = data.items;
      //     var cartArr = [];
      //     if (cartList.length > 0) {
      //       cartList.forEach((item) => {
      //         var list = {
      //           product_id: item.product_id,
      //           price: item.original_line_price,
      //         };
      //         cartArr.push(list);
      //       });
      //       console.log("data", cartArr);
      //       // 请求接口拿到金额
      //     }
      //     return data;
      //   });
      // this.getTotalAmount();
      $('.quantity__input[data-quantity-variant-id=49453187989720]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49453198573784]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49453191659736]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49574880084184]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49638086082776]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49638098370776]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49638100893912]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49679472918744]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49726532550872]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49726532583640]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49726532616408]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49726532649176]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49959044939992]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49959046578392]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=49959050707160]').prop('readonly', 'readonly').val("1").parent().hide();
      
      $('.quantity__input[data-quantity-variant-id=50370903441624]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=50370901147864]').prop('readonly', 'readonly').val("1").parent().hide();
      $('.quantity__input[data-quantity-variant-id=50370899804376]').prop('readonly', 'readonly').val("1").parent().hide();
      
      // 万圣节 及 黑五免费礼物 
      $('.quantity__input[data-quantity-variant-id=50819073736920]').prop('readonly', 'readonly').val("1").parent().hide();
  
      // 圣诞节 45143614488792
      // $('.cart-remove-button[data-variant-id=45143614488792]').hide();
      // $('.quantity__input[data-quantity-variant-id=45143614488792]').prev().attr('disabled',true).css('cursor','not-allowed;');
      // $('.quantity__input[data-quantity-variant-id=45143614488792]').next().attr('disabled',true).css('cursor','not-allowed;');
      // $('.quantity__input[data-quantity-variant-id=45143614488792]').attr('disabled',true);
  
      //返校季
      $('.quantity__input[data-quantity-variant-id=50696109457624]').prop('readonly', 'readonly').val("1").parent().hide();
      // 黑五 46617193283837
        // $('.cart-remove-button[data-variant-id=46617193283837]').hide();
        // $('.quantity__input[data-quantity-variant-id=46617193283837]').prev().attr('disabled',true).css('cursor','not-allowed;');
        // $('.quantity__input[data-quantity-variant-id=46617193283837]').next().attr('disabled',true).css('cursor','not-allowed;');
        // $('.quantity__input[data-quantity-variant-id=46617193283837]').attr('disabled',true);

        var product_id = ['8723973275864','8723973570776','8723973341400','8741184864472','8741185650904','8741185978584','8745690824920','8750606123224','8779804508376','8779805229272','8779806114008'];
        var superGiftSyp_id = ['8735241797848']
        var halloweenId = ['8988041445592']
        var cartContents = fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((data) => {
          var cartArr = [];
          var cartList = data.items;  
  
          // const GIFT_A_ID = 50370903441624;  //  C$170
          // const GIFT_B_ID = 50370901147864;  // C$309
          // const GIFT_C_ID = 50370899804376; // C$599
          // const GIFT_D_ID = 50696109457624; // C$319 返校季
          // let hasGiftA = false;
          // let hasGiftB = false;
          // let hasGiftC = false;
          // let hasGiftD = false;

          // {
          //   mainId: 45143614488792, // christmas gift
          //   variantIds: [44703872516312,49663333564632,49663143248088,45283350511832,50510751072472,45303340368088,45303340400856,45294366589144,45294366621912,43280355721432,43280355754200],
          //   totalQuantity: 0,
          //   hasItem: false,
          //   currentQuantity: 0
          // }
          const syncConfigs = [
          ]
          if (cartList.length > 0) {
            cartList.forEach((item) => {
              cartArr.push(item.product_id);
              // if (item.id === GIFT_A_ID) hasGiftA = true;
              // if (item.id === GIFT_B_ID) hasGiftB = true;
              // if (item.id === GIFT_C_ID) hasGiftC = true;
              // if (item.id === GIFT_D_ID) hasGiftD = true;
              syncConfigs.forEach(config => {
                if (config.variantIds.includes(item.id)) {
                  config.totalQuantity += item.quantity || 0;
                }
                if (item.id === config.mainId) {
                  config.hasItem = true;
                  config.currentQuantity = item.quantity;
                }
              });
            });
          }
          // 合并删除操作对象
          const delOperations = {};
          // 合并添加操作数组
          const addItems = [];
          // 处理每种商品的同步逻辑
          syncConfigs.forEach(config => {
            const { mainId, totalQuantity, hasItem, currentQuantity } = config;
            
            if (totalQuantity >= 0) {
              const currentQty = hasItem ? currentQuantity : 0;
              
              if (totalQuantity > currentQty) {
                // 需要添加商品
                addItems.push({
                  id: mainId,
                  quantity: totalQuantity - currentQty
                });
              } else if (totalQuantity !== 0 && totalQuantity < currentQty) {
                // 需要减少商品数量
                delOperations[mainId] = currentQty - totalQuantity;
              } else if (totalQuantity === 0 && hasItem) {
                // 需要完全移除商品
                delOperations[mainId] = 0;
              }
            }
          });
        
          // // 批量执行操作
          if (Object.keys(delOperations).length > 0) {
            this.clearcart(delOperations);
          }
          if (addItems.length > 0) {
            this.addCart({ items: addItems });
          }
        //   if(hasGiftA || hasGiftB || hasGiftC || hasGiftD){
        //      // 清空购物车赠品
        //     let del = {
        //       50370903441624: 0,
        //       50370901147864: 0,
        //       50370899804376: 0,
        //       50696109457624: 0
        //     };
        //     this.clearcart(del)
        //  }
          const commonElements = product_id.filter(item => cartArr.some(otherItem => otherItem == item));
          const sypElements = superGiftSyp_id.filter(item => cartArr.some(otherItem => otherItem == item));
          const halloweenElements = halloweenId.filter(item => cartArr.some(otherItem => otherItem == item));
          if(commonElements && commonElements.length > 0){
              $('.auto2-free-gift .product-form__submit').attr('disabled',true);
              $("#auto2-free-gift-tips").show();   
              $('#updates_8723973275864').hide();
              $('#updates_8723973570776').hide();
              $('#updates_8723973341400').hide();
              $('#updates_8741184864472').hide();
              $('#updates_8741185650904').hide();
              $('#updates_8741185978584').hide();
              $('#updates_8745690824920').hide();
              $('#updates_8750606123224').hide();
              $('.product div[data-id="8750606123224"] #reset_button').show().attr('disabled', true);
              $('.product div[data-id="8750606123224"] .product-form__off').show();
              $('.product div[data-id="8750606123224"] .product-form__off').text('* Already have one in your cart');
                setTimeout(function(){
                   $('#cart_recom1_8750606123224.product-form__submit,#updates_8750606123224.product-form__submit,#cart_recom1_8723973275864.product-form__submit,#cart_recom1_8723973570776.product-form__submit,#cart_recom1_8723973341400.product-form__submit,#cart_recom1_8741184864472.product-form__submit,#cart_recom1_8741185650904.product-form__submit,#cart_recom1_8741185978584.product-form__submit,#cart_recom1_8745690824920.product-form__submit,#cart_recom1_8779804508376.product-form__submit,#cart_recom1_8779805229272.product-form__submit,#cart_recom1_8779806114008.product-form__submit').attr('disabled', true);
                },1000);
          }else{
              $('.auto2-free-gift .product-form__submit').attr('disabled',false);
              $("#auto2-free-gift-tips").hide();
              $('#updates_8723973275864').show();
              $('#updates_8723973570776').show();
              $('#updates_8723973341400').show();
              $('#updates_8741184864472').show();
              $('#updates_8741185650904').show();
              $('#updates_8741185978584').show();
              $('#updates_8745690824920').show();
              $('#updates_8750606123224').show();
              $('.product div[data-id="8750606123224"] #reset_button').hide().attr('disabled', false);
              $('.product div[data-id="8750606123224"] .product-form__off').hide();
                setTimeout(function(){
                   $('#cart_recom1_8750606123224.product-form__submit,#updates_8750606123224.product-form__submit,#cart_recom1_8723973275864.product-form__submit,#cart_recom1_8723973570776.product-form__submit,#cart_recom1_8723973341400.product-form__submit,#cart_recom1_8741184864472.product-form__submit,#cart_recom1_8741185650904.product-form__submit,#cart_recom1_8741185978584.product-form__submit,#cart_recom1_8745690824920.product-form__submit,#cart_recom1_8779804508376.product-form__submit,#cart_recom1_8779805229272.product-form__submit,#cart_recom1_8779806114008.product-form__submit').attr('disabled', false);
                },1000);
          }
          
          if(sypElements && sypElements.length > 0){
             $('.auto2-dialog-addcart .product-form__submit').attr('disabled',true);
             $(".auto2-claim-now-tips").show();
          }else{
             $('.auto2-dialog-addcart .product-form__submit').attr('disabled',false);
             $(".auto2-claim-now-tips").hide();
          }
          if(halloweenElements && halloweenElements.length > 0){
             $('#updates_8988041445592').attr('disabled', true);
              $('.product div[data-id="8988041445592"] .product-form__off').text('Free gift successfully added. Limited to one per order.').show();
             setTimeout(function(){
               $('#cart_recom1_8988041445592.product-form__submit').attr('disabled', true);
            },1000);
          }else{
             $('#updates_8988041445592').attr('disabled', false);
              $('.product div[data-id="8988041445592"] .product-form__off').hide();
             setTimeout(function(){
               $('#cart_recom1_8988041445592.product-form__submit').attr('disabled', false);
            },1000);
          }
          return data;
        });
    }
  
    clearcart(updates) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }
    addCart(updates) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(updates)
      })
      .then(response => {
          return response.json();
      })
      .then(() => {
        this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
      })
      .catch((error) => {
          console.error('Error:', error);
      });
    }
    getTotalAmount(){
      var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json()).then(data => {
        const products = data.items.map(item => ({
            productId: item.product_id,
            amountOfMoney: (item.final_line_price) / 100
          })
        );
        var activityCode = $('.calculated-amount').attr('id')
        var data = {
          'site': 'CA_HTVRONT(shopify)',
          'activityCode':activityCode,
          'products': products,
        };
        var RSAdata = {
          version: '1.0.0',
          timestamp: new Date().getTime(),
          project: 'htvRont',
          token: 'f8d045ef1350411894cb9659f6e9dce9',
        };
        var rsaEncryptData = RsaEncrypt(JSON.stringify(RSAdata));
        var jsonData = JSON.stringify(data);
        $.ajax({
          url: 'https://qn.htvront.com/promotion/totalAmount',
          method: 'post',
          data: jsonData,
          contentType: 'application/json',
          headers: {
            Authorization: 'Bearer ' + `${rsaEncryptData}`,
          },
          success: function (res) {
            if (res.code == 200) {
              $('.calculated-amount').show();
              $('.calculated-amount-total-price>b').text(res.data.total);
              var couponAmount;
              if (res.data.nextMoney != -1) {
                if(res.data.couponCode == ''){
                  res.data.couponCode = 1;
                }
                if(res.data.nextType == 2){
                  couponAmount =  Number(res.data.nextAmount)*100 + '%';
                }else{
                  couponAmount = 'C$' + Math.floor(res.data.nextAmount);
                }
                $(`#calculated-amount-text-${res.data.couponCode}>i`).text(couponAmount);
                $(`#calculated-amount-text-${res.data.couponCode}>b`).text(res.data.nextMoney);
                $(`#calculated-amount-text-${res.data.couponCode}>span`).text(Math.floor(res.data.nextTotalAmount)); 
                $(`#calculated-amount-text-${res.data.couponCode}`).show().siblings().hide();
              } else {
                $('#code-last-text').show().siblings().hide();
              }
              $(`#coupons-bottom-item-${res.data.couponCode}`).show().siblings().hide();
            }
          },
          error: function (xhr, status, error) { },
        });
      });
    };
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    resetQuantityInput(id) {
      const input = this.querySelector(`#Drawer-quantity-${id}`);
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  
    setValidity(event, index, message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
      this.resetQuantityInput(index);
      event.target.select();
    }
  
    validateQuantity(event) {
      const inputValue = parseInt(event.target.value);
      const index = event.target.dataset.index;
      let message = '';
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
      }
      if (message) {
        this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          index,
          inputValue,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
    }
  
    onChange(event) {
      if(event.target.name == "note"){
        return
      }
      this.validateQuantity(event);
    }
  
    onCartUpdate() {
      if (this.tagName === 'CART-DRAWER-ITEMS') {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }
      ];
    }
  
    updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cartDrawer-item');
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.querySelector('.cart_drawer_totals');
          
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cartDrawer-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          
          // 总金额变化 进度条变化 start
          /*var totalNumber = Number(parsedState.total_price) / 100;
          var progressBar = document.querySelector('.progress-bar');
          var percentage = (totalNumber / 80) * 100;
          progressBar.style.width = `${percentage}%`;*/
          // 总金额变化 进度条变化 end
  
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
      
    }
  
    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      //console.log(html,selector)
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  customElements.define('cart-items', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();
  
          this.addEventListener(
            'input',
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, ON_CHANGE_DEBOUNCE_TIMER)
          );
        }
      }
    );
  }
  